module.exports = __webpack_public_path__ + "static/img/event22.82652aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event22.png
// module id = o+Z3
// module chunks = 1